<template>
  <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      title="更改密码"
      width="460px"
      @close="dialogClose">
    <div style="text-align: center;color: red;margin-bottom: 15px">仅支持修改eMES密码，OA密码请到OA进行修改</div>
    <el-form
        ref="form"
        class="changePwdForm"
        :model="changePwd"
        size="small">
      <el-form-item prop="username" :rules="$rule.notNull">
        <el-input v-model="changePwd.username" placeholder="请输入" clearable>
          <template slot="prepend">账号</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="oldPassword" :rules="$rule.notNull">
        <el-input
            v-model="changePwd.oldPassword"
            placeholder="请输入"
            type="password"
            show-password
            clearable>
          <template slot="prepend">原密码</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="newPassword" :rules="[$rule.notNull,$rule.password]">
        <el-input
            v-model="changePwd.newPassword"
            placeholder="请输入"
            type="password"
            clearable
            @change="checkPassword(changePwd.newPassword)">
          <template slot="prepend">新密码</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="confirmNewPassword" :rules="[$rule.notNull,$rule.password]">
        <el-input
            v-model="changePwd.confirmNewPassword"
            placeholder="请输入"
            type="password"
            clearable>
          <template slot="prepend">确认新密码</template>
        </el-input>
      </el-form-item>
      <el-button
          :loading="submitLoading"
          style="width: 100%;margin-top: 10px"
          type="primary"
          size="medium"
          @click="submit">
        提交
      </el-button>
    </el-form>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        showUsername: false,
        changePwd: {
          username: "",
          oldPassword: "",
          newPassword: "",
          confirmNewPassword: "",
          loginType: 2,
        },
      };
    },
    methods: {
      open(username) {
        this.changePwd.username = username || "";
        this.dialogVisible = true;
      },
      checkPassword(newPassword) {
        if (newPassword) {
          const hasRepeatedDigits = /(\d)\1{2}/;
          if (hasRepeatedDigits.test(newPassword)) {
            return this.$message.error("禁止出现重复数字！");
          }
          const hasSequentialDigits = /(?:012|123|234|345|456|567|678|789)/;
          if (hasSequentialDigits.test(newPassword)) {
            return this.$message.error("禁止出现连续数字！");
          }
          // eslint-disable-next-line no-useless-escape
          const passwordRegex = /^(?!.*(\d)\1{2})(?!.*(?:012|123|234|345|456|567|678|789))(?:(?=.*[A-Z])(?=.*[a-z])(?=.*\d)|(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])|(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])|(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])).{8,20}$/;
          if (!passwordRegex.test(newPassword)) {
            return this.$message.error("按照监管要求，密码必须包含【大写字母、小写字母、数字、符号】中的3种组合，长度为8-20位！");
          }
        }
      },
      dialogClose() {
        this.$refs.form.resetFields();
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.checkPassword(this.changePwd.newPassword);
            if (this.changePwd.newPassword !== this.changePwd.confirmNewPassword) {
              this.$message.error("两次输入的新密码不一致");
              return;
            }
            this.submitLoading = true;
            this.$http
              .get("basic", "account/changePassword", this.changePwd)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$message.success("密码修改成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
<style lang="scss">
.changePwdForm {
  .el-input-group__prepend {
    width: 72px;
    text-align: center;
    padding: 0 5px;
  }
}
</style>
